export const CheckedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height="14"
    width="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.05 2.131L6.796 13.357a.96.96 0 01-.312.23.89.89 0 01-.737 0 .96.96 0 01-.312-.23L.949 8.446a1.066 1.066 0 01-.209-.342 1.142 1.142 0 010-.807c.048-.128.12-.244.209-.342a.962.962 0 01.312-.229.89.89 0 01.737 0c.117.053.223.131.312.229l3.806 4.167L15.69.642a.923.923 0 01.68-.309c.256 0 .5.111.681.31.18.197.282.465.282.745 0 .28-.101.547-.282.745l-.001-.002z"
      fill="currentColor"
    />
  </svg>
);
